<template>
    <div class="unauthorizedWrapper">
        <el-card class="create_header">
            <h3>创作中心未开通，请先认证！</h3>
        </el-card>
        <el-card v-if="isUpload" class="create_upload">
            <div class="upload_content">
                <div class="tip">
                    <h3>认证资料:</h3>
                </div>
                <label class="id_upload" for="idCard">
                    <img v-if="card_image" :src="card_image" class="upImg"/>
                    <div class="upload_text" v-else>
                        <i></i>
                        <p>上传身份证正面</p>
                    </div>
                    <input type="file" id="idCard" class="upload_input"
                           @change.self="handleAvatarSuccess($event, 'idCard')"/>
                </label>

                <label class="id_upload" for="certified">
                    <img v-if="certified_image" :src="certified_image" class="upImg"/>
                    <div class="upload_text" v-else>
                        <i></i>
                        <p>上传教师资格证照片</p>
                    </div>
                    <input type="file" id="certified" class="upload_input"
                           @change.self="handleAvatarSuccess($event, 'certified')"/>
                </label>
            </div>
            <div class="unload_select">
                <el-checkbox v-model="isChecked"/>
                我已同意<a href="http://www.g12e.org/appPrivacy/yhxy.shtml" target="_blank">《中小学联盟网用户协议》</a>和<a href="http://www.g12e.org/appPrivacy/ysxy.shtml" target="_blank">《网站用户隐私政策》</a>
            </div>
            <el-button type="primary" round size="small" class="upload_btn" @click="uploadBtn">提 交</el-button>
        </el-card>
        <el-card v-else class="create_check">
            <p>审核进度：</p>
            <div v-show="!isUpload" class="check_step">
                <el-steps :active="step" align-center>
                    <el-step title="资料提交"/>
                    <el-step title="资料审核中"/>
                    <el-step :class="isVerify !== 2 ? '' : 'isVerify_fail'" :title="isVerify !== 2 ? '审核通过' : '审核未通过'"/>
                </el-steps>
                <el-tooltip v-if="isVerify === 2" class="item" effect="light" placement="bottom">
                    <div slot="content">
                        {{ fail_content }}, 请
                        <a class="cursor resubmit" style="cursor: pointer; color: #1082ff;" @click="onResubmit">
                            重新提交
                        </a>
                    </div>
                    <div class="isVerify_fail_tooltip"></div>
                </el-tooltip>
            </div>
        </el-card>
    </div>
</template>
<script>
  import { checkUserVerify, uploadVerify } from '@/api/resource';
  import { $Cookies } from '@/utils';
  import { uploadImage } from '@/api/user';

  export default {
    name: 'Unauthorized',
    data () {
      return {
        isChecked: false,
        isUpload: true,
        fail_content: '',
        isVerify: 0,
        card_image: '',
        certified_image: '',
        filesList: {
          idCard: null,
          certified: null
        },
        step: 2
      };
    },
    async mounted () {
      await this.getVerify();
    },
    methods: {
      async getVerify () {
        const userNo = $Cookies.get('uid');
        await checkUserVerify(userNo).then(data => {
          if (data.success) {
            const { isVerify, reason = '请重新提交' } = data.result;
            this.isVerify = isVerify;
            switch (isVerify) {
              case -1:
                this.isUpload = true;
                break;
              case 0:
                this.isUpload = false;
                break;
              case 1:
                this.$router.push('/creator/upload');
                break;
              case 2:
                this.fail_content = reason;
                break;
            }
          } else {
            this.$message({
              type: 'error',
              message: data.errorMsg
            });
          }
        });
      },
      authImage (url, type) {
        const authToken = $Cookies.get('authToken');
        let _path = url.split('/upload')[ 1 ];
        _path = `/api/upload${ _path }`;
        let xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.open('GET', _path, true);
        xhr.setRequestHeader('Authorization', authToken);
        xhr.onreadystatechange = () => {
          if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
            if (type === 'idCard') {
              this.card_image = URL.createObjectURL(xhr.response);
            } else if (type === 'certified') {
              this.certified_image = URL.createObjectURL(xhr.response);
            }
          }
        };
        xhr.send(null);
      },
      handleAvatarSuccess (event, type) {
        const files = event.target.files[ 0 ];
        const formData = new FormData();
        formData.append('origin', 'g12e_auth');
        formData.append('wmType', 1);
        formData.append('files', files);
        uploadImage(formData).then(data => {
          if (data.success) {
            const { sArray } = data.result;
            let url = sArray[ 0 ].url;
            if (type === 'idCard') {
              this.filesList.idCard = url;
            } else if (type === 'certified') {
              this.filesList.certified = url;
            }
            this.authImage(url, type);
          } else {
            this.$message({
              type: 'error',
              message: data.errorMsg
            });
          }
        });
      },
      uploadBtn () {
        const userNo = $Cookies.get('uid');
        if (!this.filesList.idCard) {
          this.$message({
            showClose: true,
            message: '请先上传身份证正面照片',
            type: 'warning'
          });
          return false;
        }
        if (!this.filesList.certified) {
          this.$message({
            showClose: true,
            message: '请先上传教师资格证照片',
            type: 'warning'
          });
          return false;
        }
        if (!this.isChecked) {
          this.$message({
            showClose: true,
            message: '上传前请先阅读并同意《中小学联盟网用户协议》和《网站用户隐私政策》',
            type: 'warning'
          });
          return false;
        }
        const params = {
          userNo: userNo,
          file1: this.filesList.idCard,
          file2: this.filesList.certified,
        };
        uploadVerify(params).then(data => {
          if (data.success) {
            this.$confirm('提交成功，我们将在36小时内进行初审受理', '提示', {
              showCancelButton: false,
              type: 'success',
              center: true
            }).then(() => {
              this.getVerify();
            });
          } else {
            this.$message({
              type: 'error',
              message: data.errorMsg
            });
          }
        });
      },
      onResubmit () {
        this.isUpload = true;
      }
    }
  };
</script>
